import { IconProps } from './types';
import classnames from 'classnames';

export default function CursorLeftIcon(props: IconProps) {
  const { className, style } = props;

  return (
    <svg
      className={classnames('h-4 w-4', className)}
      viewBox="0 0 24 24"
      fill="none"
      style={style}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12.586 12.586 19 19"></path>
      <path d="M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z"></path>
    </svg>
  );
}
